import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy,NavParams } from '@ionic/angular';

import { AppComponent } from './app.component';

import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule ,HTTP_INTERCEPTORS} from '@angular/common/http';
import { DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';

// import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
 import { LocationAccuracy } from '@awesome-cordova-plugins/location-accuracy/ngx';
// import { BackgroundMode } from '@awesome-cordova-plugins/background-mode/ngx';
// import { BackgroundGeolocation } from '@ionic-native/background-geolocation/ngx';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { HttpConfigInterceptor } from './httpConfig.interceptor';
import { GlobalPage } from './global/global.page';
import { Storage } from '@ionic/storage';

import { Device } from '@awesome-cordova-plugins/device/ngx';
import { SQLite } from '@awesome-cordova-plugins/sqlite/ngx';
import { UserdetailPage } from './userdetail/userdetail.page';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';
import { Diagnostic } from '@awesome-cordova-plugins/diagnostic/ngx';
// import{PopoverPage} from '../app/popover/popover.page'
import { SettingComponent } from './setting/setting.component';
import { Network } from '@ionic-native/network/ngx';
import BackgroundGeolocation from 'cordova-background-geolocation-lt';
import { IonicStorageModule } from '@ionic/storage-angular';
// import { MyDatePickerModule } from 'mydatepicker';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { File } from '@ionic-native/file/ngx';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { SignatureVerificationPage } from './signature-verification/signature-verification.page';
import { FirebaseX } from '@awesome-cordova-plugins/firebase-x/ngx';
@NgModule({
  declarations: [AppComponent,SettingComponent],
  entryComponents: [],
  imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule,FormsModule,HttpClientModule
    // , SignaturePadModule,
     ,IonicStorageModule.forRoot(),
    //  MyDatePickerModule
    ],
  providers:
  
  [  StatusBar, FirebaseX,{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: LocationStrategy, useClass: HashLocationStrategy },{
    provide: HTTP_INTERCEPTORS,
    useClass: HttpConfigInterceptor,
    multi: true
  },
  DatePipe,
  AndroidPermissions,
  Diagnostic,
  Geolocation,LocationAccuracy,GlobalPage,Storage,ScreenOrientation,
  NavParams,Device,SQLite,UserdetailPage,AppVersion, Network, 
  BackgroundGeolocation, SplashScreen, File, FileOpener, InAppBrowser,SignatureVerificationPage],
    
  bootstrap: [AppComponent],
})

export class AppModule {}
